<script>
  import {Pie} from 'vue-chartjs'

  export default {
    extends: Pie,
    name: "privilege-stats",
    mounted() {
      // Overwriting base render method with actual data.
      this.renderChart({
        labels: ['Льготные', 'Без льгот', 'Отказавшиеся'],
        datasets: [
          {
            data: [26, 294, 40],
            backgroundColor: [
              'rgb(66, 133, 244)',
              'rgb(52, 168, 83)',
              'rgb(251, 188, 5)',
            ],
          }
        ]
      }, {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom'
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/PrivilegeStats.vue